import { API_BASE_URL } from '@synergy/config';
import { FormattedMessage } from 'react-intl';
import { ReactNode } from 'react';
import { connect } from 'react-redux';
import { padZeroLeft } from '@synergy/utils';

import { AppState } from '../../../store/store';
import { BaseAutocompleteSuggestionType } from '../pool-autocomplete-list';
import { BonusSettlementSearchCustomer } from '../../../features/bonus-settlements/models/bonus-settlement-detail';
import { CustomerApi } from '../../api/customer-api';
import { PoolFormAutocompleteList } from '../../abstract/form-autocomplete-list';
import { User } from '../../models/user';

interface PartialCustomer extends BaseAutocompleteSuggestionType {
    name: string;
    isMain?: ReactNode;
}

interface PoolCustomerBonusSettlementAutocompleteListBaseProps {
    user: User;
    supplierBonusSettlementId: number;
}

class PoolCustomerBonusSettlementAutocompleteListBase extends PoolFormAutocompleteList<
    BonusSettlementSearchCustomer,
    PartialCustomer,
    PoolCustomerBonusSettlementAutocompleteListBaseProps
> {
    private api = new CustomerApi(API_BASE_URL);
    private searchParams = new URLSearchParams({ limit: '40' });

    public label = (<FormattedMessage id="app.label.customer" />);

    public componentDidMount() {
        this.setState({ items: [] });
    }

    public getSuggestionValue = (suggestion: PartialCustomer) => suggestion && suggestion.name;

    public async handleValueChanged(search: string) {
        this.searchParams.set('search', search);
        const response = await this.api.getCustomerBonusSettlements(
            this.props.supplierBonusSettlementId,
            this.searchParams
        );
        const items = response.success ? response.result.items : [];
        this.setState({ items });
    }

    public getPartial = (items: BonusSettlementSearchCustomer[]): PartialCustomer[] =>
        items.map(customer => {
            return {
                id: padZeroLeft(customer.id, 5),
                name: customer.name,
                city: customer.city || '',
            };
        });
}

const mapStateToProps = (state: AppState) => ({
    user: state.user,
});

export const PoolCustomerBonusSettlementAutocompleteList = connect(
    mapStateToProps,
    {}
)(PoolCustomerBonusSettlementAutocompleteListBase);
